<template>
  <section id="corporateSponsors">
    <div class="container">
      <h2>Corporate Sponsors</h2>
      <div class="sponsor" v-for="sponsor in sponsors">
        <div class="logo"><img :src="sponsor.logo.sizes.medium" class="img-fluid"></div>
        <div class="content">
          <h5 v-html="sponsor.name"></h5>
          <p v-html="sponsor.description"></p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'corporate-sponsors',
  props: ['sponsors']
}
</script>

<style lang="scss" scoped>
@import '~assets/styles/vars';

section {
  padding: 7rem 0 6rem;
  background-color: white;
  .container {
    @include media('desktop') {
      width: 830px;
    }
  }
}

h2 {
  color: $brand-primary;
  margin-bottom: 3rem;
  text-align: center;
}

.sponsor {
  margin-bottom: 3.25rem;
  @include media('tablet') {
    display: flex;
    align-items: center;
  }
  .logo {
    width: 220px;
    margin-right: 5rem;
  }
  .content {
    flex: 1;
    h5 {
      font-size: 1rem;
      font-weight: bold;
      text-transform: uppercase;
    }
    p {
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// CorporateSponsors.vue?2a27b226